module.exports = __webpack_public_path__ + "img/projet-musicien.59d8d8e.jpg";